import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useModal} from "../../../../../hooks";
import {AxiosError} from "axios";
import {SalesRevenueByCompanyUpdateType} from "../interface";
import {updateRevenue} from "../../../../../api/main/SalesApi";

interface Props {
    closeCallback: () => any
}

export const useUpdateRevenue = ({closeCallback}: Props) => {
    const {handleModal} = useModal();
    const qc = useQueryClient()

    const {mutate} = useMutation({
        mutationFn: (data: SalesRevenueByCompanyUpdateType[]) => updateRevenue(data),
        onSuccess: (res) => {
            if (res.data.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: "저장되었습니다",
                    type: "alert",
                    closeAction: () => {
                        qc.invalidateQueries({queryKey: ["readRevenueByCompany"]})
                        closeCallback()
                    }
                });
            } else {
                handleModal({
                    isOpen: true,
                    contents: res.data.msg,
                    type: "alert",
                });
            }
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate};
};
